module.exports = __webpack_public_path__ + "static/media/background.3051fb73.jpg";